import buttonBlockAnimation from "./button-block";
import pageHeadingBannerAnimation from "./page-heading-banner";

const componentTimelineStore = {
	buttonBlock: buttonBlockAnimation,
	pageHeadingBanner: pageHeadingBannerAnimation
}

export default componentTimelineStore;